import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Collapsible card section — neutral, no colored icon badges.
 */
export default function CollapsibleSection({
  title,
  description,
  icon: Icon,
  defaultOpen = true,
  children,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`app-collapsible ${className}`.trim()}>
      <button
        type="button"
        className="app-collapsible__header"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <div className="flex items-center gap-3 min-w-0">
          {Icon && (
            <Icon
              className="w-5 h-5 shrink-0"
              strokeWidth={1.75}
              style={{ color: 'var(--text-muted)' }}
              aria-hidden
            />
          )}
          <div className="text-left min-w-0">
            <div className="app-readable text-[15px] font-semibold" style={{ color: 'var(--text-primary)' }}>
              {title}
            </div>
            {description && (
              <div className="app-readable text-[12.5px] mt-0.5" style={{ color: 'var(--text-muted)' }}>
                {description}
              </div>
            )}
          </div>
        </div>
        <ChevronDown
          className={`w-5 h-5 shrink-0 transition-transform ${open ? 'rotate-180' : ''}`}
          style={{ color: 'var(--text-muted)' }}
        />
      </button>
      {open && <div className="app-collapsible__body">{children}</div>}
    </div>
  );
}
